import axios from '../../shared/axios';

export function destroy(profileId)
{
    return axios.delete(route('api.manage.calendar.destroy', { profileId })).then(response => response.data);
}

export function token(scopes, companyId) {
    return axios.post(route('api.manage.calendar.token'), {scopes, companyId}).then(response => response.data);
}

export function availability()
{
    return axios.post(route('api.manage.calendar.availability')).then(response => response.data);
}

export function deleteAvailabilityRules()
{
    return axios.post(route('api.manage.calendar.delete-availability-rules')).then(response => response.data);
}

export function setAvailabilityRules(data)
{
    return axios.post(route('api.manage.calendar.set-availability-rules'), data).then(response => response.data);
}

export function updateTimeZone(data)
{
    return axios.post(route('api.manage.calendar.update-time-zone'), data).then(response => response.data);
}

export function sync()
{
    return axios.post(route('api.manage.calendar.sync')).then(response => response.data);
}

export function setPrimaryCalendar(calendarId)
{
    return axios.patch(route('api.manage.calendar.set-primary'), {calendarId}).then(response => response.data);
}

export function availabilities(data)
{
    return axios.post(route('api.manage.calendar.availabilities'), data)
        .then(({data}) => data);
}

export function getAvailabilityPeriods(data)
{
    return axios.post(route('api.manage.calendar.available-periods'), data)
        .then(response => response.data);
}

export function readEvents(fromDate, toDate) {
    return axios.get(route('api.manage.companies.calendar.read-events'), {
        params: {
            from: fromDate,
            to: toDate,
        }
    }).then(response => response.data);
}
